import { type AxiosResponse } from 'axios'

import { type CustomAxiosConfig } from '@/types/axios'
import { type Doctor } from '@/types/Doctor'

import armSecureAxios from './secure-base'

export const fetchAllDoctors = async (config?: CustomAxiosConfig): Promise<AxiosResponse<Doctor[]>> => {
  return await armSecureAxios.get('/doctors/all', { ...config })
}

const doctorArmService = {
  fetchAllDoctors
}

export default doctorArmService
